import { Checkbox } from '@mui/material'
import { AutocompleteRenderOptionState } from '@mui/material/Autocomplete'

interface Props {
  optionKey: string
  optionProps: any
  name: string
  state: AutocompleteRenderOptionState
}

export const RenderOption = ({ optionKey, optionProps, name, state }: Props) => {
  return (
    <li key={optionKey} {...optionProps} className="flex flex-row items-center cursor-pointer">
      <Checkbox id={name} checked={state.selected} />
      {name}
    </li>
  )
}
